module.exports = __webpack_public_path__ + "static/img/card_2_2.0298537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/card_2_2.png
// module id = ux6w
// module chunks = 0